<p-toast></p-toast>
<p-fieldset legend="Linked Items" [toggleable]="true">
    <div class="col mb-2">
        <app-delegation-linked-items-panel-list (sendLinkedItemData)="getLinkedItemDataToSave($event)"></app-delegation-linked-items-panel-list>
    </div>
  </p-fieldset>
  <p-fieldset legend="Search Linked Items" [toggleable]="true">
    <div *ngIf="isDocumentSearchEnabled">
    <div class="col mb-2">
      <app-document-library-search #docSearch (shouldAddLinkItemsButtonDisplayed)="checkAndEnableAddLinkItemButton($event)" (emitSelectedData)="linkedItemsSelectedData($event)"
      [panelListScreen]="delegationLinkedItems"></app-document-library-search>
    </div>
    <div class="col mb-2" *ngIf="isDisplayAddLinkedItems" >
    <p-button
    appPreventDoubleClick
      label="Add Linked Document"
      icon="fa fa-plus"
      id="addLinkedItemsButton"
      styleClass="p-button-outlined"
      iconPos="left"
      [disabled]="btnDisabled"
      pTooltip="Add linked Document"
      (debounceClick)="addLinkedItems(docSearch)"
    >
    </p-button>
  </div>
    </div>
  </p-fieldset>

<div class="buttons col mb-2">
    <p-button
    appPreventDoubleClick
      label="Save"
      type="submit"
      id="delegateDetailsSaveButton"
      class="align-right"
      styleClass="bpt-button-compact"
      (debounceClick)="updateDelegate()"
    >
    </p-button>  
    <p-button
    appPreventDoubleClick
      label="Previous"
      type="submit"
      id="delegateDetailsSaveButton"
      class="align-left"
      styleClass="bpt-button-compact"
      (debounceClick)="moveToPreviousTab()"
    >
    </p-button>  
  </div>
